import activity from './activity.svg'
import alertTriangle from './alert-triangle.svg'
import alignLeft from './align-left.svg'
import archive from './archive.svg'
import arrowDownLeft from './arrow-down-left.svg'
import arrowLeft from './arrow-left.svg'
import arrowNarrowLeft from './arrow-narrow-left.svg'
import arrowNarrowRight from './arrow-narrow-right.svg'
import arrowRight from './arrow-right.svg'
import arrowUpRight from './arrow-up-right.svg'
import bankNote01 from './bank-note-01.svg'
import barChartSquare02 from './bar-chart-square-02.svg'
import bold01 from './bold-01.svg'
import briefcase02 from './briefcase-02.svg'
import building02 from './building-02.svg'
import calendar from './calendar.svg'
import check from './check.svg'
import chevronDown from './chevron-down.svg'
import chevronLeftDouble from './chevron-left-double.svg'
import chevronLeft from './chevron-left.svg'
import chevronRight from './chevron-right.svg'
import chevronUp from './chevron-up.svg'
import circle from './circle.svg'
import clock from './clock.svg'
import code02 from './code-02.svg'
import copy01 from './copy-01.svg'
import copy06 from './copy-06.svg'
import cube01 from './cube-01.svg'
import currencyDollarCircle from './currency-dollar-circle.svg'
import dotsVertical from './dots-vertical.svg'
import edit03 from './edit-03.svg'
import edit05 from './edit-05.svg'
import eyeOff from './eye-off.svg'
import eye from './eye.svg'
import globe03 from './globe-03.svg'
import globe05 from './globe-05.svg'
import hash02 from './hash-02.svg'
import infoCircle from './info-circle.svg'
import inbox01 from './inbox-01.svg'
import layersThree01 from './layers-three-01.svg'
import lifeBuoy01 from './life-buoy-01.svg'
import loading01 from './loading-01.svg'
import logOut01 from './log-out-01.svg'
import logoDark from './logo-dark.svg'
import logoLight from './logo-light.svg'
import logomark from './logomark.svg'
import mail01 from './mail-01.svg'
import markerPin01 from './marker-pin-01.svg'
import markerPin02 from './marker-pin-02.svg'
import menu05 from './menu-05.svg'
import messageDotsCircle from './message-dots-circle.svg'
import minus from './minus.svg'
import notificationBox from './notification-box.svg'
import package01 from './package-01.svg'
import phoneCall01 from './phone-call-01.svg'
import plusCircle from './plus-circle.svg'
import plus from './plus.svg'
import printer from './printer.svg'
import reverseLeft from './reverse-left.svg'
import searchLg from './search-lg.svg'
import share01 from './share-01.svg'
import settings01 from './settings-01.svg'
import star01 from './star-01.svg'
import star04 from './star-04.svg'
import sunSetting01 from './sun-setting-01.svg'
import sun from './sun.svg'
import switchVertical01 from './switch-vertical-01.svg'
import tooltip from './tooltip.svg'
import trash01 from './trash-01.svg'
import uploadCloud02 from './upload-cloud-02.svg'
import user01 from './user-01.svg'
import user03 from './user-03.svg'
import userPlus01 from './user-plus-01.svg'
import users01 from './users-01.svg'
import xClose from './x-close.svg'
import zoom from './zoom.svg'
import monitor02 from './monitor-02.svg'
import phone02 from './phone-02.svg'
import tablet01 from './tablet-01.svg'
import facebook from './facebook.svg'
import twitter from './twitter.svg'
import instagram from './instagram.svg'
import moon01 from './moon-01.svg'
import ellipse01 from './ellipse-01.svg'
import home01 from './home-01.svg'
import videoRecorder from './video-recorder.svg'
import userLeft01 from './user-left-01.svg'
import userRight01 from './user-right-01.svg'
import clockRewind from './clock-rewind.svg'
import emptyState01 from './empty-state-01.svg'
import notificationText from "./notification-text.svg"
import map02 from './map-02.svg'
import creditCard02 from "./credit-card-02.svg"
import magicWand02 from "./magic-wand-02.svg"
import dotsMove from "./dots-move.svg"
import palette from "./palette.svg"
import upload01 from "./upload-01.svg"
import rows01 from "./rows-01.svg"
import grid01 from "./grid-01.svg"
import grid04 from "./grid-04.svg"
import cameraPlus from "./camera-plus.svg"
import leftBottom from "./left-bottom.svg"
import rightBottom from "./right-bottom.svg"
import leftTop from "./left-top.svg"
import rightTop from "./right-top.svg"
import maximize02 from "./maximize-02.svg"
import type01 from "./type-01.svg"
import textInput from "./text-input.svg"
import cursorBox from "./cursor-box.svg"
import border from "./border.svg"
import filled from "./filled.svg"
import flat from "./flat.svg"
import line from "./line.svg"
import rounded from "./rounded.svg"
import repeat04 from "./repeat-04.svg"
import sunSetting02 from "./sun-setting-02.svg"
import moonStar from "./moon-star.svg"
import link02 from "./link-02.svg"


export default {
    activity, alertTriangle, alignLeft, archive, arrowLeft, arrowNarrowLeft, arrowNarrowRight,
    arrowRight, bankNote01, barChartSquare02, bold01, briefcase02, building02, calendar, check,
    chevronDown, chevronLeftDouble, chevronLeft, chevronRight, chevronUp,
    circle, clock, code02, copy06, copy01, cube01, currencyDollarCircle, dotsVertical, edit03, edit05, eyeOff, eye, globe03,
    hash02, infoCircle, inbox01, layersThree01, lifeBuoy01, loading01, logOut01,
    logoDark, logoLight, logomark, mail01, markerPin01, markerPin02, menu05,
    messageDotsCircle, minus, notificationBox, package01, phoneCall01, plusCircle, plus, printer, home01, videoRecorder,
    reverseLeft, searchLg, settings01, share01, star01, star04, sunSetting01, sun, switchVertical01, tooltip, moon01,
    trash01, uploadCloud02, user01, user03, userPlus01, users01, xClose, zoom, monitor02, phone02, tablet01, facebook, twitter, instagram, ellipse01, userLeft01, userRight01,
    arrowDownLeft, arrowUpRight, clockRewind, emptyState01, notificationText, map02, creditCard02, magicWand02, dotsMove, palette, upload01, rows01, grid01, grid04, cameraPlus,
    leftBottom, rightBottom, leftTop, rightTop, maximize02, type01, textInput, cursorBox, border, filled, flat, line, rounded, repeat04, sunSetting02, moonStar, globe05, link02

}